var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-fluid py-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "row funko-filter-category"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('ul', {
    staticClass: "list-group list-group-horizontal-sm-down list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item funko-li-title"
  }, [_vm._v("Filtros:")]), _vm._l(_vm.categorias, function (categoria, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('input', {
      staticClass: "form-check-input funko-categorias-filter-check",
      attrs: {
        "id": "input-check-".concat(index),
        "type": "checkbox"
      },
      domProps: {
        "checked": categoria.isCheched
      },
      on: {
        "click": function click($event) {
          return _vm.handleOnCheck(index);
        }
      }
    }), _c('label', {
      staticClass: "form-check-label funko-li-title-item",
      attrs: {
        "for": "input-check-".concat(index)
      }
    }, [_vm._v(" " + _vm._s(categoria.label) + " ")])])]);
  }), _c('li', {
    staticClass: "list-group-item funko-li-price-item"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('b-form-input', {
    staticClass: "form-check-input funko-categorias-filter-check funko-range-price",
    attrs: {
      "id": "input-range-price",
      "type": "range",
      "min": _vm.priceMin,
      "max": _vm.priceMax,
      "step": _vm.priceStep
    },
    model: {
      value: _vm.priceFilter,
      callback: function callback($$v) {
        _vm.priceFilter = $$v;
      },
      expression: "priceFilter"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "input-range-price"
    }
  }, [_vm._v(" " + _vm._s(_vm.getLabelPrice(_vm.priceFilter)) + " ")])], 1)])], 2)])])]), _c('div', {
    staticClass: "col-sm-12 col-md-9 col-lg-9"
  }, [_c('CardCategorias', {
    attrs: {
      "categorias": _vm.getFunkosFiltered
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }